import { createSlice } from '@reduxjs/toolkit';

import { ApiStatus } from 'const';
import {
  CHANGE_ACCOUNT_PASSWORD_SUBMIT,
  SEND_OTP
} from 'redux/sagas/actions/account';

const initialState = {
  otpStatus: false,
  serviceStatus: false
};

export const ERROR_FIELD_TYPE = {
  code: 'code',
  password: 'password',
  newPassword: 'newPassword',
  serviceResponse: 'serviceResponse'
};

const setError = (state, action) => {
  state.errorMessage = action.payload.message;
  state.errorType = action.payload.type;
  if (action.payload.type === 'serviceResponse') {
    state.serviceStatus = true;
    state.status = ApiStatus.error;
  }
};

export const accountSlice = createSlice({
  name: '@@account',
  initialState,
  reducers: {
    SET_ACCESS_ERROR: setError,
    RESET_STATE: () => initialState
  },
  extraReducers: {
    [CHANGE_ACCOUNT_PASSWORD_SUBMIT._ERROR]: setError,
    [SEND_OTP._SUCCESS]: state => {
      state.otpStatus = true;
    },
    [CHANGE_ACCOUNT_PASSWORD_SUBMIT._SUCCESS]: state => {
      state.errorMessage = null;
      state.serviceStatus = true;
      state.status = ApiStatus.success;
    }
  }
});

export const { SET_ACCESS_ERROR, RESET_STATE } = accountSlice.actions;
export default accountSlice.reducer;
